 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddressPicker":"AddressPicker","Agent":"Agent","AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea":"AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea","AgentChargingOrder~AgentChargingOrderDetail~AgentReport~AgentWallet~BalanceCash~BalanceGift~DeviceFo~95c313ba":"AgentChargingOrder~AgentChargingOrderDetail~AgentReport~AgentWallet~BalanceCash~BalanceGift~DeviceFo~95c313ba","AgentChargingOrderDetail":"AgentChargingOrderDetail","AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog":"AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog","AgentChargingOrder":"AgentChargingOrder","AgentReport":"AgentReport","AgentWallet":"AgentWallet","BalanceCash":"BalanceCash","BalanceGift":"BalanceGift","UserChargingOrder":"UserChargingOrder","AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList":"AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList","DeviceForm~PowerNearby~PowerRecharge~UnionLogin~UserRecharge":"DeviceForm~PowerNearby~PowerRecharge~UnionLogin~UserRecharge","DeviceForm":"DeviceForm","PowerRecharge":"PowerRecharge","UnionLogin":"UnionLogin","Login~Syncfee":"Login~Syncfee","Login":"Login","UserChargingOrderDetail":"UserChargingOrderDetail","UserRechargeLog":"UserRechargeLog","AgentDetail":"AgentDetail","AgentForm":"AgentForm","AgentList":"AgentList","AgentProfile":"AgentProfile","AgentProfileUpdate":"AgentProfileUpdate","DeviceDetail":"DeviceDetail","StationDetail~StationForm":"StationDetail~StationForm","StationForm":"StationForm","StationList":"StationList","Agreement":"Agreement","PowerNearby":"PowerNearby","UserRecharge":"UserRecharge","DeviceGun":"DeviceGun","DeviceList":"DeviceList","Home":"Home","Syncfee":"Syncfee","StationDetail":"StationDetail","StationFee":"StationFee","StationProfitSharing":"StationProfitSharing","UserProfile":"UserProfile","UserRechargeDetail":"UserRechargeDetail","AgentDashboard":"AgentDashboard","Device":"Device","Forbidden":"Forbidden","GeneralAgent":"GeneralAgent","GeneralAgentDashboard":"GeneralAgentDashboard","NotFound":"NotFound","Power":"Power","Station":"Station","User":"User","UserDashboard":"UserDashboard"}[chunkId]||chunkId) + "." + {"AddressPicker":"71a2eb99","Agent":"9d9fa1c8","AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea":"d3e873a8","AgentChargingOrder~AgentChargingOrderDetail~AgentReport~AgentWallet~BalanceCash~BalanceGift~DeviceFo~95c313ba":"b29ed86b","AgentChargingOrderDetail":"94d36caa","AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog":"c0f5e2b0","AgentChargingOrder":"d6d9757d","AgentReport":"51a485d9","AgentWallet":"1d120a86","BalanceCash":"f0b6e6f7","BalanceGift":"41852b54","UserChargingOrder":"93451b0d","AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList":"f0c8eb21","DeviceForm~PowerNearby~PowerRecharge~UnionLogin~UserRecharge":"801f6d70","DeviceForm":"be375e87","PowerRecharge":"c23e2809","UnionLogin":"aae3c259","Login~Syncfee":"787c0c3d","Login":"4d50e5c5","UserChargingOrderDetail":"6c531bb9","UserRechargeLog":"e135fcc1","AgentDetail":"52a2be20","AgentForm":"adf61e4b","AgentList":"265cdb67","AgentProfile":"3919f40e","AgentProfileUpdate":"f06023a2","DeviceDetail":"a88a41af","StationDetail~StationForm":"3c775cd5","StationForm":"d92927b4","StationList":"6a44ab9c","Agreement":"ba1a3470","PowerNearby":"b23e4869","UserRecharge":"01dfe69f","DeviceGun":"09484220","DeviceList":"d6d358da","Home":"0113aef9","Syncfee":"f1e7a73a","StationDetail":"c5210f38","StationFee":"f1814405","StationProfitSharing":"dcfe3d1d","UserProfile":"49f280b1","UserRechargeDetail":"3b44e61a","AgentDashboard":"12d22a9d","Device":"e98b601a","Forbidden":"f2fe9e49","GeneralAgent":"2e012398","GeneralAgentDashboard":"0e3dbd73","NotFound":"8ea0dc49","Power":"8a31e7a5","Station":"9bd6bd4a","User":"e535e323","UserDashboard":"afc23c74"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AddressPicker":1,"AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea":1,"AgentChargingOrderDetail":1,"AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog":1,"AgentChargingOrder":1,"AgentReport":1,"AgentWallet":1,"BalanceCash":1,"BalanceGift":1,"UserChargingOrder":1,"AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList":1,"DeviceForm":1,"PowerRecharge":1,"UnionLogin":1,"Login~Syncfee":1,"Login":1,"UserChargingOrderDetail":1,"UserRechargeLog":1,"AgentDetail":1,"AgentForm":1,"AgentList":1,"DeviceDetail":1,"StationDetail~StationForm":1,"StationForm":1,"StationList":1,"PowerNearby":1,"UserRecharge":1,"DeviceGun":1,"DeviceList":1,"Home":1,"Syncfee":1,"StationDetail":1,"StationFee":1,"StationProfitSharing":1,"UserProfile":1,"UserRechargeDetail":1,"AgentDashboard":1,"GeneralAgentDashboard":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddressPicker":"AddressPicker","Agent":"Agent","AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea":"AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea","AgentChargingOrder~AgentChargingOrderDetail~AgentReport~AgentWallet~BalanceCash~BalanceGift~DeviceFo~95c313ba":"AgentChargingOrder~AgentChargingOrderDetail~AgentReport~AgentWallet~BalanceCash~BalanceGift~DeviceFo~95c313ba","AgentChargingOrderDetail":"AgentChargingOrderDetail","AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog":"AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog","AgentChargingOrder":"AgentChargingOrder","AgentReport":"AgentReport","AgentWallet":"AgentWallet","BalanceCash":"BalanceCash","BalanceGift":"BalanceGift","UserChargingOrder":"UserChargingOrder","AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList":"AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList","DeviceForm~PowerNearby~PowerRecharge~UnionLogin~UserRecharge":"DeviceForm~PowerNearby~PowerRecharge~UnionLogin~UserRecharge","DeviceForm":"DeviceForm","PowerRecharge":"PowerRecharge","UnionLogin":"UnionLogin","Login~Syncfee":"Login~Syncfee","Login":"Login","UserChargingOrderDetail":"UserChargingOrderDetail","UserRechargeLog":"UserRechargeLog","AgentDetail":"AgentDetail","AgentForm":"AgentForm","AgentList":"AgentList","AgentProfile":"AgentProfile","AgentProfileUpdate":"AgentProfileUpdate","DeviceDetail":"DeviceDetail","StationDetail~StationForm":"StationDetail~StationForm","StationForm":"StationForm","StationList":"StationList","Agreement":"Agreement","PowerNearby":"PowerNearby","UserRecharge":"UserRecharge","DeviceGun":"DeviceGun","DeviceList":"DeviceList","Home":"Home","Syncfee":"Syncfee","StationDetail":"StationDetail","StationFee":"StationFee","StationProfitSharing":"StationProfitSharing","UserProfile":"UserProfile","UserRechargeDetail":"UserRechargeDetail","AgentDashboard":"AgentDashboard","Device":"Device","Forbidden":"Forbidden","GeneralAgent":"GeneralAgent","GeneralAgentDashboard":"GeneralAgentDashboard","NotFound":"NotFound","Power":"Power","Station":"Station","User":"User","UserDashboard":"UserDashboard"}[chunkId]||chunkId) + "." + {"AddressPicker":"a67c5e7a","Agent":"31d6cfe0","AgentChargingOrder~AgentChargingOrderDetail~AgentDetail~AgentForm~AgentList~AgentProfile~AgentProfil~650d50ea":"22cab52d","AgentChargingOrder~AgentChargingOrderDetail~AgentReport~AgentWallet~BalanceCash~BalanceGift~DeviceFo~95c313ba":"31d6cfe0","AgentChargingOrderDetail":"917dc383","AgentChargingOrder~AgentReport~AgentWallet~BalanceCash~BalanceGift~UserChargingOrder~UserRechargeLog":"b3411006","AgentChargingOrder":"02628803","AgentReport":"0a1fd6f4","AgentWallet":"482910dc","BalanceCash":"c89efdab","BalanceGift":"c89efdab","UserChargingOrder":"c89efdab","AgentProfile~AgentProfileUpdate~DeviceDetail~DeviceForm~StationForm~StationList":"aef4ade5","DeviceForm~PowerNearby~PowerRecharge~UnionLogin~UserRecharge":"31d6cfe0","DeviceForm":"aa7f162f","PowerRecharge":"a6d035b2","UnionLogin":"516fa707","Login~Syncfee":"d72d0953","Login":"05347529","UserChargingOrderDetail":"9c59e4c8","UserRechargeLog":"4e32bbed","AgentDetail":"4e9cd1e7","AgentForm":"a44b882b","AgentList":"cad2f5d3","AgentProfile":"31d6cfe0","AgentProfileUpdate":"31d6cfe0","DeviceDetail":"f8e1985a","StationDetail~StationForm":"835b5b4e","StationForm":"5708a106","StationList":"f9e93db8","Agreement":"31d6cfe0","PowerNearby":"09192679","UserRecharge":"c07a1488","DeviceGun":"348c162e","DeviceList":"01f65d27","Home":"1988f790","Syncfee":"e02a515e","StationDetail":"a44b882b","StationFee":"5edf91cd","StationProfitSharing":"a44b882b","UserProfile":"70f31e4c","UserRechargeDetail":"1b302fe6","AgentDashboard":"19f66b10","Device":"31d6cfe0","Forbidden":"31d6cfe0","GeneralAgent":"31d6cfe0","GeneralAgentDashboard":"28b5398d","NotFound":"31d6cfe0","Power":"31d6cfe0","Station":"31d6cfe0","User":"31d6cfe0","UserDashboard":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
